import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { portalApiClient } from '../api/portalApiClient';

/**
 * Hand-typed, mirroring opportunity's own `RepInviteAcceptRequest`/
 * `RepInviteAcceptResponse` (PP-9.4 D20) -- the BFF's `/auth/rep/invite/
 * accept` route returns a bare `JSONResponse` (no `response_model`, since it
 * is a verbatim pass-through of opportunity's own already-reviewed shape),
 * so there is no generated type to import here, same convention
 * `InviteRepRequestDraft` already established on the staff side of this app.
 */
export interface RepInviteAcceptCreate {
  readonly token: string;
}

export interface RepInviteAcceptResponse {
  readonly detail: string;
}

const acceptRepInvite = async (
  payload: RepInviteAcceptCreate,
): Promise<RepInviteAcceptResponse> => {
  const { data } = await portalApiClient.post<RepInviteAcceptResponse>(
    '/auth/rep/invite/accept',
    payload,
  );
  return data;
};

export const useAcceptRepInvite = (): UseMutationResult<
  RepInviteAcceptResponse,
  unknown,
  RepInviteAcceptCreate
> => useMutation({ mutationFn: acceptRepInvite });
